import React, { useMemo } from 'react'
import { MemoriesProvider } from '@fs/zion-memories/memories-authorized-use-only'
import { useAlbums, useAlbumsApi } from './useAlbums'

export default function MemoriesProviderWrapper({
  children,
  galleryCallbacks,
  galleryMemories,
  memoriesDirty,
  memoriesLoading,
  setMemoriesDirty,
}) {
  const { albumMemories, selectedAlbumId } = useAlbums()
  const {
    addAlbum,
    addCallback,
    addToAlbumsCallback,
    deleteCallback,
    isMemoryInAnyAlbum,
    removeFromAlbumCallback,
    updateCallback,
  } = useAlbumsApi()

  const callbacks = useMemo(
    () => ({
      ...galleryCallbacks,
      addAlbum,
      addCallback,
      addToAlbumsCallback,
      deleteCallback,
      isMemoryInAnyAlbum,
      removeFromAlbumCallback,
      setMemoriesDirty,
      updateCallback,
    }),
    [
      addAlbum,
      addCallback,
      addToAlbumsCallback,
      deleteCallback,
      galleryCallbacks,
      isMemoryInAnyAlbum,
      removeFromAlbumCallback,
      setMemoriesDirty,
      updateCallback,
    ]
  )

  const memories = selectedAlbumId ? albumMemories : galleryMemories

  return (
    <MemoriesProvider
      galleryCallbacks={callbacks}
      memories={memories}
      memoriesDirty={memoriesDirty}
      memoriesLoading={memoriesLoading}
    >
      {children}
    </MemoriesProvider>
  )
}
